export * from './buscar-pessoa-modal.component';


// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/pages/modals/buscar-pessoa-modal/index.ts